// eslint-disable-next-line import-x/default -- Invalid 3rd party types
import emojiMartData from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { type FunctionComponent, useEffect, useRef, useState } from 'react';
import { usePopper } from 'react-popper';
import { useMessageComposer, useMessageInputContext } from 'stream-chat-react';
import { MessageInputControlButton } from '../MessageInputControlsButton/MessageInputControlsButton';

// similar to EmojiPicker from "stream-chat-react/emojis"
// but with custom wrappers and button

export type EmojiPickerProps = {};

export const EmojiPicker: FunctionComponent<EmojiPickerProps> = () => {
  const referenceElement = useRef<HTMLButtonElement>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
    null,
  );
  const { attributes, styles } = usePopper(
    // eslint-disable-next-line react-hooks/refs -- Cannot call usePopper in a useEffect
    referenceElement.current,
    popperElement,
    {
      placement: 'auto-start',
    },
  );
  const { textComposer } = useMessageComposer();
  const [emojiPickerIsOpen, setEmojiPickerIsOpen] = useState(false);
  const { textareaRef } = useMessageInputContext();

  useEffect(() => {
    if (!popperElement || !referenceElement.current) {
      return;
    }

    const handlePointerDown = (e: PointerEvent): void => {
      const target = e.target as HTMLElement;

      if (
        popperElement.contains(target) ||
        referenceElement.current?.contains(target)
      ) {
        return;
      }

      setEmojiPickerIsOpen(false);
    };

    globalThis.addEventListener('pointerdown', handlePointerDown);
    return () => {
      globalThis.removeEventListener('pointerdown', handlePointerDown);
    };
  }, [referenceElement, popperElement]);

  return (
    <>
      {emojiPickerIsOpen && (
        <div
          className="str-chat__message-textarea-emoji-picker-container"
          style={styles}
          {...attributes.popper}
          ref={setPopperElement}
        >
          <Picker
            data={emojiMartData}
            onEmojiSelect={(e: { native: string }) => {
              const textarea = textareaRef.current;
              if (!textarea) {
                return;
              }
              void textComposer.insertText({ text: e.native });
              textarea.focus();
              setEmojiPickerIsOpen(false);
            }}
            theme="light"
          />
        </div>
      )}
      <MessageInputControlButton
        onClick={() => {
          setEmojiPickerIsOpen((open) => !open);
        }}
        ref={referenceElement}
        type="emoji"
      />
    </>
  );
};
